// @ts-nocheck
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { GetCurrenciesList } from '../../store/NTX/Currency/currencySlice';
import { useTranslation } from 'react-i18next';

const useLookupCurrency = () => {
  const dispatch = useDispatch();

  const { i18n } = useTranslation();
  useEffect(() => {
    if (CurrencyList?.length === 0) {
      dispatch(GetCurrenciesList());
    }
  }, [dispatch]);

  const { CurrencyList, loading, error } = useSelector(state => state.Currency);

  var Currency = CurrencyList.filter(f => f.enabledFlag);

  const CurrencyOptions = Currency?.map((item, idx) => ({
    id: item.id,
    // label: i18n.language === 'en' ? item.name : item.name2,
    label: i18n.language === 'en' ? item.description : item.description,
    value: item.currencyCode
  }));

  // const CurrencyList = Currency.map((m) => ({
  //   id: m.id,
  //   currencyCode: m.currencyCode,
  //   description: m,
  //   enabledFlag: '',
  // }));

  return { Currency, CurrencyList, CurrencyOptions, loading, error };
};

export default useLookupCurrency;
